var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-top"},[_c('search-form',{ref:"orderSearchForm",attrs:{"order-list-types":_vm.orderListTypes,"order-search-type":_vm.orderSearchTypes,"invoice-no-registered":true,"order-status-types":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }